<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="5">
        <v-row>
          <v-col cols="12">
            <v-row align="center">
              <v-col class="font-weight-medium" cols="auto">{{ $t('formUser.name') }}</v-col>
            </v-row>
            <v-text-field :value="data.name" @input="value=>updateForm('name', value)" :label="$t('formUser.name')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-row align="center">
              <v-col class="font-weight-medium" cols="auto">{{ $t('formUser.phoneNumber') }}</v-col>
            </v-row>
            <v-text-field :value="data.phoneNumber" @input="value=>updateForm('phoneNumber', value)" :label="$t('formUser.phoneNumber')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-row align="center">
              <v-col class="font-weight-medium" cols="auto">{{ $t('formUser.birthday') }}</v-col>
            </v-row>
            <v-text-field :value="data.birthday" @input="value=>updateForm('birthday', value)" :label="$t('formUser.birthday')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-row align="center">
              <v-col class="font-weight-medium" cols="auto">{{ $t('formUser.email') }}</v-col>
            </v-row>
            <v-text-field :value="data.email" @input="value=>updateForm('email', value)" :label="$t('formUser.email')" :readonly="mode === 'edit'" solo="solo" flat="flat" outlined="outlined"></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="5">
        <v-row>
          <v-col cols="12">
            <v-row align="center">
              <v-col class="font-weight-medium" cols="auto">{{ $t('formUser.joinDate') }}</v-col>
            </v-row>
            <v-text-field :value="data.joinDate" @input="value=>updateForm('joinDate', value)" :label="$t('formUser.joinDate')" :readonly="mode === 'edit'" solo="solo" flat="flat" outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-row align="center">
              <v-col class="font-weight-medium" cols="auto">{{ $t('formUser.note') }}</v-col>
            </v-row>
            <v-textarea :value="data.note" @input="value=>updateForm('note', value)" :label="$t('formUser.note')" height="380" solo="solo" flat="flat" outlined="outlined"></v-textarea>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: 'edit'
    }
  },
  methods: {
    updateForm (field, value) {
      this.$emit('update', { field, value })
    }
  }
}
</script>
